import { RadioLabelValue } from "best-common-react";

export type UITheme = "light" | "dark" | "white";

export type VenueUIConfig = {
  venueId: string;
  strikeZoneConfig?: VenueUIConfigOptions | string;
  thinConfig?: VenueUIConfigOptions | string;
  createdTs: Date;
  createdUser: string;
  updatedTs: Date;
  updatedUser: string;
};

export type VenueUIConfigOptions = {
  theme: UITheme;
  showPitchSpeed: boolean;
  showPitchType: boolean;
  showExitVelocity: boolean;
  showLaunchAngle: boolean;
  removePitchIn: number;
};

export type VenueUIConfigOptionsKeys =
  | "theme"
  | "showPitchSpeed"
  | "showPitchType"
  | "showExitVelocity"
  | "showLaunchAngle"
  | "removePitchIn";

export const DefaultUIConfig: VenueUIConfigOptions = {
  theme: "dark",
  showPitchSpeed: true,
  showPitchType: true,
  showExitVelocity: false,
  showLaunchAngle: false,
  removePitchIn: 5,
};

export const UIThemeOptions: RadioLabelValue[] = [
  {
    label: "Dark",
    value: "dark" as UITheme,
  },
  {
    label: "Light",
    value: "light" as UITheme,
  },
  {
    label: "White",
    value: "white" as UITheme,
  },
];

const SHOW_TMOB = process.env.SHOW_TMOB === "true";

if (SHOW_TMOB) {
  UIThemeOptions.push({
    label: "Magenta",
    value: "magenta" as UITheme,
  });
  UIThemeOptions.push({
    label: "Title Magenta",
    value: "title-magenta" as UITheme,
  });
  UIThemeOptions.push({
    label: "Arc Magenta",
    value: "arc-magenta" as UITheme,
  });
}
